
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DRMQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ownedBookPk"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookPk"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"drmForEpub"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ownedBookId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ownedBookPk"}}},{"kind":"Argument","name":{"kind":"Name","value":"epubId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookPk"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"printAllowancePercent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPrintable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"printAllowanceNumPages"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"printAllowanceRange"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"consecutivePrintPages"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"printTimePeriod"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rollingPrintPeriod"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"printLimitPerInstance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxPrintableChars"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxPrintablePages"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"copyPercentage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxCharsCopiable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isCopiable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"offlineSessionLimit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"offlinePercent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"offlineEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"onlineSessionCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ownedBookExpiration"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":511}};
    doc.loc.source = {"body":"query DRMQuery($ownedBookPk: Int, $bookPk: Int) {\n  drmForEpub(ownedBookId: $ownedBookPk, epubId: $bookPk) {\n    printAllowancePercent\n    isPrintable\n    printAllowanceNumPages\n    printAllowanceRange\n    consecutivePrintPages\n    printTimePeriod\n    rollingPrintPeriod\n    printLimitPerInstance\n    maxPrintableChars\n    maxPrintablePages\n    copyPercentage\n    maxCharsCopiable\n    isCopiable\n    offlineSessionLimit\n    offlinePercent\n    offlineEnabled\n    onlineSessionCount\n    ownedBookExpiration\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["DRMQuery"] = oneQuery(doc, "DRMQuery");
        
